import { colorAttentionRed50, spacingS, spacingXxs } from "@rhumbix/rmbx_design_system_design_tokens";
import React from "react";
import styled from "styled-components";
/**
 * An error message to include in forms. Our style dictates that it should be placed immediately
 * below the field it applies to
 *
 * @param children The text of the error message
 * @returns The styled error message
 */
const ErrorText = ({ children }) => (React.createElement(StyledErrorText, null, children));
const StyledErrorText = styled.div `
    color: ${colorAttentionRed50};
    margin-bottom: ${spacingS};
    margin-top: ${spacingXxs};
`;
export default ErrorText;
